import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
class SyncAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "getSyncStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carIds) => this.privateRequest('post', 'sync/get-status', { ids: carIds })
        });
        Object.defineProperty(this, "syncCarToPlatform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId) => this.privateRequest('post', `sync/${carId}/car`)
        });
        this.setConfig(config);
    }
}
export default new SyncAPI({
    baseURL: config.CarPlatformSyncAPI.url
});
